import Link from "next/link";
import UserCircleIcon from "@referralexchange/rea-ui-react/src/svgs/user-circle";

import useUser from "~/utils/useUser";
import { useEffect } from "react";
import { useAnalytics } from "~/contexts/AnalyticsContext.tsx";

export default function UserMenu({}) {
  const { user } = useUser({ redirectIfFound: false });
  const { reaa } = useAnalytics();
  return (
    <>
      {user?.isLoggedIn ? (
        <a href="/logout" onClick={() => reaa('logout_event', 'attempted', {})}>
          <div
            style={{
              width: "24px",
              height: "24px",
              display: "inline-block",
            }}
          >
            <UserCircleIcon />
          </div>{" "}
          Sign out
        </a>
      ) : (
        <Link href="/sign-in">
          <div
            style={{ width: "24px", height: "24px", display: "inline-block" }}
          >
            <UserCircleIcon />
          </div>{" "}
          Sign in
        </Link>
      )}
    </>
  );
}
